<template>
  <v-container class="links-site">
    <v-card
      class="py-4 px-2 auth-content"
      tile
      elevation="6"
    >
      <PageTitle
        icon="mdi-pencil-box-outline"
        main="Painel de notícias"
        sub="Links do site"
        home='/noticias'
      />
      <div>
        <links />
      </div>
    </v-card>
  </v-container>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import Links from '../links/index.vue'
export default {
  name: 'LinksSite',
  components: { PageTitle, Links },
  data: () => ({
  })
}
</script>
